import { Overlay } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { ProductModel } from "../../../models/product/product.model";
import { DialogService } from "../../../services/components/dialog.service";
import { DiscontinuedProductPopupService } from "../../../services/components/discontinued-product-popup.service";
import { ProductPopUpBaseComponent } from "../product-pop-up-base/product-pop-up-base.component";

@Component({
  selector: "pcg-ng-discontinued-product-pop-up",
  template: require('./discontinued-product-pop-up.component.html'),
  styles: []
})
export class DiscontinuedProductPopUpComponent extends ProductPopUpBaseComponent<ProductModel> {
  public constructor(
      popupService: DiscontinuedProductPopupService,
      overlay: Overlay,
      dialogService: DialogService
  ) {
      super(popupService, overlay, dialogService);
  }
}
